"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowNodeSpec = void 0;
class FlowNodeSpec {
    constructor(args) {
        Object.assign(this, args);
    }
}
exports.FlowNodeSpec = FlowNodeSpec;
//# sourceMappingURL=base.js.map